import { Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
  name?: string | ReactNode;
};

export const BrandVoiceName = ({ name }: Props) => (
  <LimitedTypography noWrap={true}>{name || 'Unnamed Brand Voice'}</LimitedTypography>
);

const LimitedTypography = styled(Typography)`
  font-size: inherit;
  color: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
